<template>
  <DataTable
    ref="dt"
    :loading="!transporterHeader"
    :value="header"
    :paginator="true"
    :rows="10"
    :rowClass="rowClass"
    responsiveLayout="scroll"
    class="editable-cells-table"
    filterDisplay="row"
    v-model:filters="filters"
  >
    <template #header>
      <div style="display:flex;justify-content:space-between;align-items:baseline">
        <h4>Truck</h4>
         <Button label="Save" class="col-1 p-button-success" @click="saveData"
          :disabled="hasError || !canSave"/>
      </div>
    </template>
    <Column :exportable="false" :sortable="false">
    <template #filter>
        <Button
          label="Clear"
          icon="pi pi-trash"
          style="justify-content: center"
          class="p-button-outlined p-button-primary p-button-sm"
          :badge="filterBadge"
          badgeClass="p-badge-danger"
          @click="clearFilter"
        />
      </template>
      <template #header>
        <Button
          icon="pi pi-plus"
          class="p-button-info p-button-sm"
          @click="addDetail()"
          :disabled="!canEdit"
        />
      </template>
      <template #body="slotProps">
        <Button
          icon="pi pi-minus"
          class="p-button-danger p-button-sm"
          @click="deleteDetail(slotProps.data)"
          :disabled="!canEdit"
        />
      </template>
    </Column>
    <Column field="Vehicle_No" :header="$t('vehicle_no')">
    <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('vehicle_no')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          @change='editDetail(slotProps.data)'
          @input="checkPlate(slotProps.data)"
          :disabled="!canEdit"
        />
        <br/>
        <p class="p-error">{{slotProps.data.Plate_Error}}</p>
      </template>
    </Column>
    <Column field="Capacity" :header="$t('capacity')">
    <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('capacity')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
        <InputNumber
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          :disabled="!canEdit"
          mode="decimal"
          :maxFractionDigits="2"
          :minFractionDigits="2"
          @change="editDetail(slotProps.data)"
        />
      </template>
    </Column>
     <Column field="UoM" :header="$t('uom')">
     <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('uom')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template>
      <template #body="slotProps">
      <Dropdown
                  v-model="slotProps.data[slotProps.column.props.field]"
                  class="p-inputtext-sm"
                  style="display:flex !important"
                  :options="uomOptions"
                  optionLabel="label"
                  optionValue="value"
                  :disabled="!canEdit"
                />
        </template
    ></Column>
     <Column field="Fleet_Type_Id" :header="$t('truck_type')">
      <template #body="slotProps">
        <CustomSelect
          v-model="slotProps.data[slotProps.column.props.field]"
          :url="this.$API_URL + 'list/truck_type'"
          :minLength="0"
          :filter="true"
          class="p-inputtext-sm"
          style="display:flex"
          @change="editDetail(slotProps.data)"
          :disabled="!canEdit"
        />
      </template
    ></Column>
    <Column field="Location" :header="$t('location')">
    <!-- <template #filter="{ filterModel, filterCallback }">
        <InputText
          type="text"
          :placeholder="$t('location')"
          v-if="filterModel"
          v-model="filterModel.value"
          @keydown.enter="filterCallback()"
          class="p-column-filter p-inputtext-sm"
        />
      </template> -->
       <template #body="slotProps">
        <CustomMultiSelect :disabled="!canEdit" v-model="slotProps.data.locations" :url="$API_URL + 'list/location_by_user'" :params="{ transporter_code: transporter_code}" @change="editDetail(slotProps.data)"/>
      </template>
      <!-- <template #body="slotProps">
        <InputText
          type="text"
          v-model="slotProps.data[slotProps.column.props.field]"
          class="p-inputtext-sm"
          :disabled="slotProps.data.mode==this.$FORM_MODE_CREATE"
          @click="openLocationDialog(slotProps.data)"
        />
      </template> -->
    </Column>
    
  </DataTable>
  <Location
    v-model:locationVisible="this.locationVisible"
    :model="this.locationModel"
    :transporterCode="this.transporter_code"
    :url="this.url+'/save_location'"
    title="Truck Location"
    @block-ui="block"
    @unblock-ui="unBlock"
    @success="updateLocation"
  />
</template>
<script>
export default {
  data() {
    return {
      url: this.$API_URL + "vehicle",
      locationVisible: false,
      locationModel:null,
      vehicleId:null,
      hasError:false,
      uomOptions: [
        { label: "KG", value: "KG" },
        { label: "MT", value: "MT" },
      ],
      filters:null
    };
  },
  props: {
    header: {
      type: Object,
      default: null,
    },
    mode:{
			type: String,
			default: null
		},
    blueprint: {
      type: Object,
      default: null,
    },
    transporter_code:{
      type:String,
      default:""
    },
    transporterHeader:{
      type:Object,
      default:null
    }
  },
  mounted(){
    this.setFilters()
  },
  methods: {
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        this.filters[exportable[i].props.field] = {
          value: null,
          matchMode: "contains",
        };
      }
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
     openLocationDialog(data) {
      data.Helper_Locations = data.Vehicle_Locations?data.Vehicle_Locations:[]
      this.locationVisible = true;
      this.locationModel=data
    },
    updateLocation(data){
      this.locationModel.Location = data.locName
      this.locationModel.Vehicle_Locations = data.locList
    },
    saveData() {
      var self = this;
      this.$emit("block-ui");
      this.$axios
        .post(this.url, { vehicles: this.header, mode: this.$FORM_MODE_EDIT })
        .then((response) => {
          this.$emit("unblock-ui");
          this.$toast.add({ severity: response.data.success ? 'success' : 'error', summary: response.data.success ? 'Success' : 'Error', detail: response.data.message, life: 50000});
          self.$emit("refresh-data");
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          this.$toast.add({ severity: 'error', summary: "Error", detail: err, life: 50000});
        });
    },
    rowClass(data) {
      return data
        ? data.mode == this.$FORM_MODE_DELETE
          ? "hidden"
          : ""
        : null;
    },
    addDetail() {
      var newDetail = { ...this.blueprint };
      newDetail.mode = this.$FORM_MODE_CREATE;
      newDetail.Transporter_Code = this.transporter_code
      this.header.unshift(newDetail);


			//this.$refs.dt.goToLastPage();
    },
    editDetail(data) {
      if (data.mode == this.$FORM_MODE_UNCHANGED) {
        data.mode = this.$FORM_MODE_EDIT;
      }
       this.hasError=(data.Plate_Error!="" && data.Plate_Error!=undefined)
    },
    deleteDetail(data) {
      if (data.mode == this.$FORM_MODE_CREATE) {
        var index = this.header.indexOf(data);
        this.header.splice(index, 1);
      } else {
        data.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDriver(event.data);
    },
    isBlackList(data) {
      if (!data.Blacklist) {
        data.Reason = null;
      }
    },
    block() {
      this.$emit("block-ui");
    },
    unBlock() {
      this.$emit("unblock-ui");
    },
    checkPlate(data){
       var plateNoRegex = /^[A-Z]{1,2}\s[0-9]{1,4}\s[A-Z]{1,3}$/.test(data.Vehicle_No.toUpperCase())
       data.Plate_Error=plateNoRegex?"":"Invalid vehicle number value"
    }
  },
  computed: {
     filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    dialogTitle() {
      return this.dialogType == "password"
        ? "Change Password"
        : "Change Location";
    },
    canSave(){
			return this.mode ? this.mode != this.$FORM_MODE_VIEW : false;
		},
		canEdit(){
			return this.mode ? this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT : false;
		}
  },
  emits: ["block-ui", "unblock-ui", "refresh-data"],
};
</script>
<style scoped>


.checkbox-input {
  position: absolute;
  margin: 7px 0 0 5px;
  z-index: 2;
}

.checkbox-input .p-checkbox-box {
  width: 16px;
  height: 16px;
}

.hidden {
  display: none;
}
</style>
